import { Link, useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/home';

export default function LatestArticles() {
  const navigate = useNavigate();

  const handleArticleClick = (articleId: number) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/article/${articleId}`);
  };

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h4 className="text-sm font-semibold text-accent-500 uppercase tracking-wide">
              <a href="#latest-articles">最新资讯</a>
            </h4>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
              影视资讯与评测
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <button
              key={article.id}
              onClick={() => handleArticleClick(article.id)}
              className="group text-left bg-background-50 rounded-lg overflow-hidden hover:bg-background-50/80 transition-colors cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={`${article.title} - 白云视频影视资讯`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="text-primary-500 font-medium">{article.category}</span>
                  <span>{article.date}</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span><i className="ri-eye-line text-[10px]"></i> {article.views} 阅读</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}